// App adapter over the dashboard's one analytics instance (createAnalytics, built by
// createDashboard from dashboard.config.js's `analytics` — IA_ABSORPTION_PLAN 6b-2b). Keeps the
// `useAnalytics()` call sites in App/setup.js, useAppContext.js and TeamsPageAssignment/setup.js
// unchanged. Call it where useDashboard() works: in a component's setup.
import { useDashboard } from '@rdrive/plugin-dashboard-shell';

export function useAnalytics() {
  const { analytics } = useDashboard();
  return { trackEvent: analytics.trackEvent, trackPage: analytics.trackPage };
}
